<template>
  <v-container>
    <v-row class="text-center" justify="center">
      <v-col cols="12" lg="8">
        <div v-if="intro">
          <Intro />
        </div>
        <v-fade-transition hide-on-leave>
          <div v-if="quiz">
            <h2
              ref="domandemultiple"
              class="text-center text-h6 text-sm-h5 oswald white--text my-4"
            >
              15 domande a risposta multipla
            </h2>
            <Rispostamultipla
              v-for="(item, index) in multiple"
              :key="index"
              :ind="index"
              :question="item"
              @checkMultipla="addRispostaMultipla($event)"
            />
          </div>
        </v-fade-transition>
        <v-fade-transition hide-on-leave>
          <div v-if="solved">
            <h2
              ref="rispostemultiple"
              class="text-center oswald white--text my-4"
            >
              15 domande a risposta multipla
            </h2>
            <Rispostamultiplacheck
              v-for="(item, index) in multiple"
              :key="index"
              :question="item"
              :answered="risposteMultiple[index]"
            />
          </div>
        </v-fade-transition>
        <v-fade-transition hide-on-leave>
          <Questions
            :primo="primo"
            :quiz="quiz"
            :solved="solved"
            @selezionate="creaQuiz($event)"
            @verifica="controlla"
          />
        </v-fade-transition>
        <v-fade-transition hide-on-leave>
          <Results :esatte="risultato" :dialog="dialog" @close="chiudi" />
        </v-fade-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Intro from "@/components/Intro";
import Results from "@/components/Results";
import Rispostamultipla from "@/components/Rispostamultipla";
import Rispostamultiplacheck from "@/components/Rispostamultiplacheck";
import Questions from "@/components/Questions";
export default {
  name: "Quiz",
  components: {
    Intro,
    Results,
    Rispostamultipla,
    Rispostamultiplacheck,
    Questions,
  },
  data: () => ({
    intro: true,
    solved: false,
    primo: true,
    quiz: false,
    dialog: false,
    risultato: 0,
    multiple: [],
    verofalso: [],
    risposteMultiple: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
    risposteVeroFalso: [
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
      "N",
    ],
  }),
  methods: {
    creaQuiz(domande) {
      window.scrollTo(0, 0);
      this.risultato = 0;
      this.solved = false;
      this.intro = false;
      this.primo = false;
      this.dialog = false;
      this.quiz = true;
      (this.multiple = []),
        (this.risposteMultiple = [4, 4, 4, 4, 4, 4, 4, 4, 4, 4]);
      this.multiple = domande.multiple;
      window.scrollTo(0, 0);
    },
    addRispostaMultipla(risp) {
      this.risposteMultiple[risp.indice] = risp.risposta;
    },
    chiudi() {
      this.dialog = false;
      window.scrollTo(0, 0);
    },
    controlla() {
      for (var i = 0; i < 15; i++) {
        if (this.multiple[i].right === this.risposteMultiple[i])
          this.risultato++;
      }
      this.quiz = false;
      this.primo = false;
      this.dialog = true;
      this.solved = true;
      window.scrollTo(0, 0);
    },
  },
};
</script>
